module.exports = "/images/merchant.png?6df0561f944e75b021b8eba7b0821adb";